<template>
    <div ref="dailyChart" style="width: 100%;height:400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'DailyTraffic',
    data() {
        return {
            chartInstance: null,
        }
    },
    props: ['dailyData', 'trafficDailyUnit'],
    methods: {
        initChart() {
            const chartDoms = this.$refs.dailyChart;
            if (chartDoms) {
                if (this.chartInstance) {
                    this.chartInstance.dispose();
                }
                this.chartInstance = echarts.init(chartDoms);
                this.updateChart();
            } else {
                console.error('error');
            }
        },
        updateChart() {
            if (this.chartInstance && this.dailyData) {
                var data = this.dailyData.map(item => {
                    let value = item.Sum;
                    switch (this.trafficDailyUnit) {
                        case 'M':
                            value *= 1000;
                            break;
                        case 'G':
                            value;
                            break;
                        case 'T':
                            value /= 1000;
                            break;
                        default:
                            break;
                    }
                    return [item.Timestamp, value.toFixed(2)];
                });
                var option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross' }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'time',
                        name: 'time',
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: this.trafficDailyUnit,
                        axisLabel: {
                            formatter: '{value} ' + this.trafficDailyUnit
                        }
                    },
                    series: [{
                        name: 'Traffic',
                        type: 'line',
                        stack: 'Total',
                        data: data,
                        smooth: true,
                        label: {
                            show: false,
                            position: 'top',
                            fontSize: 10
                        }
                    }]
                };
                this.chartInstance.setOption(option, true);
            } else {
                console.error('daily instance error');
            }
        },
    },
    watch: {
        dailyData(newData) {
            if (newData && newData.length > 0) {
                this.initChart();
            }
        },
        trafficDailyUnit(newUnit, oldUnit) {
            if (newUnit !== oldUnit) {
                this.updateChart();
            }
        },
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }
}
</script>
